<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Définition de processus"
                createIconText="Ajouter une définition"
                importDatasourceName="processdefinitions"
                (created)="onItemCreated()"
                (exported)="onItemsExported()"
                (imported)="onItemsImported()"
                (helped)="onHelpRequested()"></app-list-header>
        </mat-expansion-panel-header>

        <app-process-definitions-list
            #itemsList
            (itemSelected)="onItemSelected($event)"
            (itemDisplayed)="onItemDisplayed($event)"
            (itemEdited)="onItemEdited($event)"
            (itemDeleted)="onItemDeleted($event)"
            (itemDuplicated)="onItemDuplicated($event)"></app-process-definitions-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onItemDisplayed(context?.formContext.item)"
                    (edited)="onItemEdited(context?.formContext.item)"
                    (helped)="onHelpRequested()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-process-definitions-detail [context]="context" (processDefinitionUpdated)="onItemUpdated($event)" (canceled)="onBackToList()"></app-process-definitions-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
